import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgMedical(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4ZM11.5 6C10.6716 6 10 6.67157 10 7.5V10H7.5C6.67157 10 6 10.6716 6 11.5V12.5C6 13.3284 6.67157 14 7.5 14H10V16.5C10 17.3284 10.6716 18 11.5 18H12.5C13.3284 18 14 17.3284 14 16.5V14H16.5C17.3284 14 18 13.3284 18 12.5V11.5C18 10.6716 17.3284 10 16.5 10H14V7.5C14 6.67157 13.3284 6 12.5 6H11.5Z", fill: "currentColor" })));
}
export default SvgMedical;
